import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

export default function Downloads() {
  const { t } = useTranslation();

  const downloadCategories = [
    {
      title: t('downloadsPage.catalogs'),
      icon: 'ri-book-open-line',
      items: [
        { name: 'Product Catalog 2024', size: '4.2 MB', format: 'PDF' },
        { name: 'Pointing Machines Overview', size: '2.8 MB', format: 'PDF' },
        { name: 'Straightening Machines Overview', size: '3.1 MB', format: 'PDF' },
      ],
    },
    {
      title: t('downloadsPage.technicalDocs'),
      icon: 'ri-file-list-3-line',
      items: [
        { name: 'Technical Specifications - Wire Pointing', size: '1.5 MB', format: 'PDF' },
        { name: 'Technical Specifications - Bar Pointing', size: '1.3 MB', format: 'PDF' },
        { name: 'Maintenance Manual - General', size: '5.2 MB', format: 'PDF' },
        { name: 'Installation Guide', size: '3.8 MB', format: 'PDF' },
      ],
    },
    {
      title: t('downloadsPage.certificates'),
      icon: 'ri-award-line',
      items: [
        { name: 'ISO 9001:2015 Certificate', size: '1.1 MB', format: 'PDF' },
        { name: 'CE Declaration of Conformity', size: '0.8 MB', format: 'PDF' },
      ],
    },
  ];

  return (
    <Layout>
      {/* Page Header */}
      <div className="bg-foreground-900 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider mb-4 block">
            {t('nav.downloads')}
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
            {t('downloadsPage.title')}
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-2xl">
            {t('downloadsPage.subtitle')}
          </p>
        </div>
      </div>

      {/* Downloads Content */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {downloadCategories.map((category) => (
              <div
                key={category.title}
                className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
              >
                <div className="px-6 py-5 bg-background-100 border-b border-background-200 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                    <i className={`${category.icon} text-lg text-primary-500`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">
                    {category.title}
                  </h3>
                </div>
                <div className="p-6">
                  <div className="space-y-3">
                    {category.items.map((item) => (
                      <div
                        key={item.name}
                        className="flex items-center justify-between p-3 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer group"
                      >
                        <div className="flex items-center gap-3">
                          <i className="ri-file-pdf-line text-primary-400 group-hover:text-primary-500 transition-colors"></i>
                          <div>
                            <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                              {item.name}
                            </p>
                            <p className="text-xs text-foreground-500">
                              {item.format} &middot; {item.size}
                            </p>
                          </div>
                        </div>
                        <i className="ri-download-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}